import {WatchlistType} from "./WatchlistType";
import {CodeAndExchange, Securities, securityEquality} from "app/instruments/types/CodeAndExchange";
import {WatchlistRecord, WatchlistRecords} from "./WatchlistRecord";
import {AccountSecuritiesRecords} from "./AccountSecuritiesRecord";
import {ArrayUtil} from "../../js/util/ArrayUtil";
import {flatMap} from "../../js/util/UtilFunctions";
import {CreateWatchlistId, WatchlistId} from "./WatchlistId";
import {Exchange} from "../../instruments/exchange/Exchange";

export type WatchlistModels = ReadonlyArray<WatchlistModel>;

export interface WatchlistModel {
    readonly id: WatchlistId;
    readonly name: string;
    readonly type: WatchlistType;
    readonly securities: ReadonlyArray<CodeAndExchange>;
}

export function BuildUserModels(records: WatchlistRecords): WatchlistModels {
    return records.map(buildUserModel);
}

export const PortfolioWatchlistId = CreateWatchlistId("my-portfolio", WatchlistType.SYSTEM);

export const XJO: CodeAndExchange = {code: "XJO", exchange: Exchange.ASX};

export function BuildPortfolioModel(records: AccountSecuritiesRecords): WatchlistModel {
    const securitiesAndXjo = records.map((r) => r.securities)
                                    .reduce(flatMap, [])
                                    .concat(XJO);

    const securities = ArrayUtil.distinct(securitiesAndXjo, securityEquality());

    return {
        id: PortfolioWatchlistId,
        name: "watchlist.MY_PORTFOLIO",
        type: WatchlistType.SYSTEM,
        securities
    };
}

function buildUserModel(record: WatchlistRecord): WatchlistModel {
    return {
        id: CreateWatchlistId(record.id, WatchlistType.USER),
        name: record.name,
        type: WatchlistType.USER,
        securities: record.securities
    };
}

export const AdviserWatchListId = CreateWatchlistId("adviser-list", WatchlistType.SYSTEM);

export function BuildAdviserModel(securities: Securities): WatchlistModel {
    return {
        id: AdviserWatchListId,
        name: "Watchlist",
        type: WatchlistType.SYSTEM,
        securities
    };
}
